export const replaceAll = (str, find, replace) => {
	return str.replace(new RegExp(find, 'g'), replace);
}

export const createSeed = (): number => {
	return Math.floor(Math.random()* Number.MAX_SAFE_INTEGER - 1);
}
